/** Description: It's the result object of the API data.  */
export class ApiResponse<T> {
    public success!: boolean;
    public message!: string;
    public data!: T;
}